module.exports = __webpack_public_path__ + "static/media/slide3.4b4f77b4.jpg";